define('viewmodels/ResetPassword',['plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/system', 'services/logger'],
function (router, appsecurity, navigation, system, logger) {
    var CpViewModel = {
        activate: activate,
        attached: attached,
        appsecurity: appsecurity,
        OldPassword: ko.observable(""),
        NewPassword: ko.observable(""),
        ReEnterNewPassword: ko.observable(""),
        SubmitResetPassword: SubmitResetPassword,
        ResetForm: ResetForm,
        PasswordHelp: PasswordHelp,
        PasswordHelpToolTip: ko.observable(),
        PageType: ko.observable("Screen"),
        PasswordLocked: ko.observable(false),
        QueryParams: ko.observable(),
        Email: ko.observable(""),
        ProviderName: ko.observable("SMSCode"),
        PhoneNumber: ko.observable(),
        OtpText: ko.observable('Send the MFA verification code to your registered email address:'),
        VerifyPhoneNumber: VerifyPhoneNumber,
        SubmitOnetimepassword: SubmitOnetimepassword,
        Wrongattemptcount: ko.observable(3),
        OTPPassword: ko.observable(),
        CreateOneTimePassword: CreateOneTimePassword,
        AuthenticateOption: AuthenticateOption,
        MaskedNumber: ko.observable(),
        CallPhone: CallPhone,
        TwoFactorEnabled: ko.observable()

        //passwordparams

    };
    CpViewModel.NewPassword.subscribe(function (newValue) {
        if (newValue != undefined && newValue != "") {
            var flagValue = validatePassword(newValue);
            if (!flagValue) {
                CpViewModel.password("");
                $('#pswd_info>ul>li>i').removeClass('fa-check').addClass('fa-close');
                $('#pswd_info>ul>li').removeClass('valid').addClass('invalid');
            }
        }
    });
    return CpViewModel;

    function activate(QueryParam) {
        try {
            CpViewModel.QueryParams(QueryParam.QueryParam);
        }
        catch (e) {
            var msg = 'Exception' + e + ' Source | activate() in ResetPassword.js';
            logger.logMessage(msg);
        }
    }

    function attached() {
        try {
            $('#loginPageLogo').hide();
            $('#loadingMainImgDiv').hide();
            //$("#txtPassword").val('');
            $("body").removeClass("login-container").addClass("login-page");
            DefaultButton =
                $("header").css({ "display": "none" });

            $('.login-image-container').hide();
            $("body").removeClass("login-page");
            $('body').addClass("hold-transition");
            $('.main-header').hide();
            $('.main-sidebar').hide();
            $("#master-header-content").removeClass("content-wrapper");
            $("#shellWrapper").removeClass("content-wrapper");


            //GetphoneNumber();
            ResetForm();
            loadJsFunctions();
            //   GetIsTwoFactorEnabled();
        }
        catch (e) {
            var msg = 'Exception' + e + ' Source | attached() in ResetPassword.js';
            logger.logMessage(msg);
        }
    }
    function GetIsTwoFactorEnabled(EmailId) {
        try
        {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/Account/GetTwoFactorEnabledDetails",
                type: "POST",
                headers: headers,
                data: { Email: EmailId }
            })
                .success(function (jsonResult, status)
                {
                    if (jsonResult != null && jsonResult.startsWith('INC')) {
                        logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CpViewModel), true);
                    }

                    else if (jsonResult != null && !jsonResult.startsWith('INC')) {
                        CpViewModel.TwoFactorEnabled(jsonResult);
                    }

                    else {
                        logger.logError('An error has occurred. Please contact your Administrator.', 'Error', system.getModuleId(CpViewModel), true);
                    }
                })
            .fail(function (error, status) {
                if (error.status == 400) {
                    ResetForm();
                    logger.logError('Unable to fetch details. Please try again.', 'Error', system.getModuleId(CpViewModel), true);
                }
                else if (error.status == 500) {
                    ResetForm();
                    logger.logError('Invalid URL Link. Please try again.', 'Error', system.getModuleId(CpViewModel), true);
                }
                else {
                    var msg = 'Exception: ' + error + ' | Source:ajaxFail method in GetIsTwoFactorEnabled() method in ResetPassword.js';
                    logger.logMessage(msg);
                }
            });
        }
        catch (e) {
            var msg = 'Exception' + e + ' Source | GetIsTwoFactorEnabled() in ResetPassword.js';
            logger.logMessage(msg);
        }
    }

    function SubmitResetPassword() {
        try {
            $('#loadingMainImgDiv').show();
            if (CpViewModel.Email() == "") {
                $('#valErrorCp').text('Email Address is required.');
                $('#valErrorCp').show();
                $('#loadingMainImgDiv').hide();
            }
            else if (CpViewModel.NewPassword() == "") {
                $('#valErrorCp').text('New Password is required.');
                $('#valErrorCp').show();
                $('#loadingMainImgDiv').hide();
            }
            else if (CpViewModel.ReEnterNewPassword() == "") {
                $('#valErrorCp').text('Please re-enter the new password.');
                $('#valErrorCp').show();
                $('#loadingMainImgDiv').hide();
            }
            else if (CpViewModel.ReEnterNewPassword() != CpViewModel.NewPassword()) {
                $('#valErrorCp').text('There is a mismatch between the new password and the re-entered new password.');
                $('#valErrorCp').show();
                $('#loadingMainImgDiv').hide();
            }
            else {
                if (validatePassword(CpViewModel.NewPassword())) {
                    $('#valErrorCp').hide();
                    GetIsTwoFactorEnabled(CpViewModel.Email()).then(function () {
                        if (CpViewModel.TwoFactorEnabled() == 'True') {
                            CpViewModel.OtpText('Send the MFA verification code to your registered email address:');
                            //GetphoneNumber();
                            // CpViewModel.OtpText(CpViewModel.OtpText() + " with a verification code");
                            // CpViewModel.MaskedNumber(jsonResult[1])
                            //$('select option:contains("SMS")').text('Text me at ' + jsonResult[1]);
                            //$('select option:contains("Call")').text('Call me at ' + jsonResult[1]);
                            $('#MessageDiv').show();
                            $('#loadingMainImgDiv').hide();
                            $('#PhoneNumeberdiv').hide();
                            $('#Passwordsection').hide();
                        }
                        else {
                            ResetPassword(CpViewModel.Email(), CpViewModel.NewPassword(), CpViewModel.ReEnterNewPassword());
                        }
                    })
                    //  

                }
                else {
                    $('#valErrorCp').text('New password does not meet the password guidelines.');
                    $('#valErrorCp').show();
                    $('#loadingMainImgDiv').hide();
                }
            }
        }
        catch (e) {
            var msg = 'Exception' + e + ' Source | SubmitResetPassword() in ResetPassword.js';
            logger.logMessage(msg);
        }
    }

    function ValidateNewPassword(Password) {
        try {
            var Result = false;
            var SpecialCharCount = 0;
            var UpperCaseCount = 0;
            var NumberCount = 0;
            var LowerCaseCount = 0;
            for (var i = 0; i < Password.length; i++) {
                var CharCode = Password.charCodeAt(i);
                if (CharCode >= 65 && CharCode <= 90)
                    UpperCaseCount++;
                else if (CharCode >= 97 && CharCode <= 122)
                    LowerCaseCount++;
                else if (CharCode >= 48 && CharCode <= 57)
                    NumberCount++;
                else
                    SpecialCharCount++;
            }

            if (Password.length < 10 || UpperCaseCount < 1 || SpecialCharCount < 1)
                Result = false;
            else
                Result = true;
            return Result;
        }
        catch (e) {
            var msg = 'Exception' + e + ' Source | ValidateNewPassword() in ResetPassword.js';
            logger.logMessage(msg);
        }
    }

    function ResetForm() {
        try {
            $('#AuthenticateDiv').hide();
            $('#MessageDiv').hide();
            $('#Telephonecalldiv').hide();
            $('#PhoneNumeberdiv').hide();
            $('#Passwordsection').show();
            CpViewModel.Email("");
            CpViewModel.NewPassword("");
            CpViewModel.ReEnterNewPassword("");
        }
        catch (e) {
            var msg = 'Exception' + e + ' Source | ResetForm() in ResetPassword.js';
            logger.logMessage(msg);
        }
    }


    function ResetPassword(Email, NewPassword, ConfirmPassword) {
        try {
            var key = CryptoJS.enc.Utf8.parse('8080808080808080');
            var iv = CryptoJS.enc.Utf8.parse('8080808080808080');
            var encryptedNewPwd = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(NewPassword), key,
                {
                    keySize: 128 / 8,
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                });
            $('#txtNewEncryption').val(encryptedNewPwd);
            var newPwd = $('#txtNewEncryption').val();

            var encryptedConfirmPwd = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(ConfirmPassword), key,
                {
                    keySize: 128 / 8,
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                });
            $('#txtencryption').val(encryptedConfirmPwd);
            var confirmPwd = $('#txtencryption').val();

            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Account/SetPassword",
                type: "POST",
                headers: headers,
                contentType: 'application/json',
                data: ko.toJSON({
                    Email: Email,
                    Password: newPwd,
                    ConfirmPassword: confirmPwd,
                    Code: CpViewModel.QueryParams(),
                    PhoneNumber: CpViewModel.PhoneNumber(),
                    Isverfiedphonenumber: false
                })
            })
        .success(ajaxSuccess)
        .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call from ChangeUserPassword() method in ResetPassword.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null && jsonResult.startsWith('INC')) {
                    $('#loadingMainImgDiv').hide();
                    ResetForm();
                    logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CpViewModel), true);
                }

                else if (status == 'success') {
                    $('#loadingMainImgDiv').hide();
                    logger.logSuccess('Password changed successfully. Please login with the new password.', 'Success', system.getModuleId(CpViewModel), true);
                    LogoutForm();
                    
                }
              //else {
              //     $('#loadingMainImgDiv').hide();
              //      ResetForm();
              //      logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CpViewModel), true);
              //  }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess method in ChangeUserPassword() method in ResetPassword.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                $('#loadingMainImgDiv').hide();

                if (error.status == 400) {
                    ResetForm();
                    logger.logError('The code is incorrect. Please try again.', 'Error', system.getModuleId(CpViewModel), true);
                }
                else if (error.status == 500) {
                    ResetForm();
                    logger.logError('Invalid URL Link. Please try again.', 'Error', system.getModuleId(CpViewModel), true);
                }
                else {
                    var msg = 'Exception: ' + error + ' | Source:ajaxFail method in ChangeUserPassword() method in ResetPassword.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail method in ChangeUserPassword() method in ResetPassword.js';
                logger.logMessage(msg);
            }
        }

    }

    function LogoutForm() {
        try {
            debugger;
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Account/Logout",
                type: "POST",
                headers: headers
        });
            appsecurity.clearAuthInfo();

        // appsecurity.logout();
        router.navigate('login')
        CpViewModel.PageType("Screen");
    }
            catch (e) {
        var msg = 'Exception: ' + e + ' | Source:ajaxFail method in ChangeUserPassword() method in ResetPassword.js';
        logger.logMessage(msg);
    }
    }

    function PasswordHelp(data, event) {
        CpViewModel.PasswordHelpToolTip("Password Guidelines 1.  Minimum of eight alphanumeric characters 2.  At least one upper case character 3.  At least one non-standard character (!,*,_,etc…)")
        // $(event.currentTarget).tooltip('show');

    }

    function validatePassword(strPassword) {
        try {
            return (strPassword.match(/[a-z]/) && strPassword.match(/[A-Z]/) && strPassword.match(/\d/) && strPassword.length >= 10 && checkSpecialCharacters(strPassword));
        }
        catch (e) {
            logger.logError("Error in method: validatePassword", null, data, false);
        }
    }

    function checkSpecialCharacters(data) {
        try {
            var iChars = "!@#$%^&*()+=-[]\\\';,./{}|\":<>?~_";
            for (var i = 0; i < data.length; i++) {
                if (iChars.indexOf(data.charAt(i)) != -1) {
                    return true;
                }
            }
            return false;
        }
        catch (e) {
            logger.logError("Error in method: checkSpecialCharacters", null, data, false);
        }
    }
    function loadJsFunctions() {
        $('#txtNewPAssword').keyup(function () {
            var pswd = $(this).val();
            //validate lower case letter
            if (pswd.match(/[a-z]/)) {
                $('#lblLowerCase').removeClass('invalid').addClass('valid');
                $('#lblLowerCase>i').removeClass('fa-close').addClass('fa-check');
            } else {
                $('#lblLowerCase').removeClass('valid').addClass('invalid');
                $('#lblLowerCase>i').removeClass('fa-check').addClass('fa-close');
            }
            //validate upper case letter
            if (pswd.match(/[A-Z]/)) {
                $('#lblUpperCase').removeClass('invalid').addClass('valid');
                $('#lblUpperCase>i').removeClass('fa-close').addClass('fa-check');
            } else {
                $('#lblUpperCase').removeClass('valid').addClass('invalid');
                $('#lblUpperCase>i').removeClass('fa-check').addClass('fa-close');
            }
            //validate number
            if (pswd.match(/\d/)) {
                $('#lblNumber').removeClass('invalid').addClass('valid');
                $('#lblNumber>i').removeClass('fa-close').addClass('fa-check');
            } else {
                $('#lblNumber').removeClass('valid').addClass('invalid');
                $('#lblNumber>i').removeClass('fa-check').addClass('fa-close');
            }
            //validate punctuation
            if (checkSpecialCharacters(pswd)) {
                $('#lblPunctuation').removeClass('invalid').addClass('valid');
                $('#lblPunctuation>i').removeClass('fa-close').addClass('fa-check');
            } else {
                $('#lblPunctuation').removeClass('valid').addClass('invalid');
                $('#lblPunctuation>i').removeClass('fa-check').addClass('fa-close');
            }
            //validate the length
            if (pswd.length < 10) {
                $('#lblLength').removeClass('valid').addClass('invalid');
                $('#lblLength>i').removeClass('fa-check').addClass('fa-close');
            } else {
                $('#lblLength').removeClass('invalid').addClass('valid');
                $('#lblLength>i').removeClass('fa-close').addClass('fa-check');
            }
            //validate the better length
            if (pswd.length >= 12) {
                $('#lblBetterLength').removeClass('invalid').addClass('valid');
                $('#lblBetterLength>i').removeClass('fa-close').addClass('fa-check');
            } else {
                $('#lblBetterLength').removeClass('valid').addClass('invalid');
                $('#lblBetterLength>i').removeClass('fa-check').addClass('fa-close');
            }
        }).focus(function () {
            $('#pswd_info').show();
        }).blur(function () {
            $('#pswd_info').hide();
        });
    }

    function GetphoneNumber() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Account/GetResetPhoneNumber",
                type: "POST",
                headers: headers,
                contentType: 'application/json',
                data: JSON.stringify
                        ({
                            Email: CpViewModel.Email()
                        })
            })
                .success(function (jsonResult, status)
                {
                    if (jsonResult != null && jsonResult.startsWith('INC'))
                    {
                        logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CpViewModel), true);
                    }

                    else if (jsonResult != null && !jsonResult.startsWith('INC'))
                {
                    if (jsonResult[0] == 'No User') {
                        $('#MessageDiv').hide();
                        $('#loadingMainImgDiv').hide();
                        $('#PhoneNumeberdiv').hide();
                        $('#Passwordsection').hide();
                        logger.logError('Unable to verify account, Please contact Application Administrator.', 'Error', system.getModuleId(CpViewModel), true);
                    }
                    else {
                        CpViewModel.PhoneNumber(jsonResult[0]);
                        CpViewModel.OtpText(CpViewModel.OtpText() + " " + jsonResult[1] + " with a verification code");
                        CpViewModel.MaskedNumber(jsonResult[1])
                        $('select option:contains("SMS")').text('Text me at ' + jsonResult[1]);
                        $('select option:contains("Call")').text('Call me at ' + jsonResult[1]);
                        $('#MessageDiv').show();
                        $('#loadingMainImgDiv').hide();
                        $('#PhoneNumeberdiv').hide();
                        $('#Passwordsection').hide();
                    }
                }
                else {
                    $("#numberprovider").intlTelInput({
                        allowExtensions: true,
                        autoFormat: false,
                        autoHideDialCode: false,
                        autoPlaceholder: false,
                        defaultCountry: "auto",
                        ipinfoToken: "yolo",
                        nationalMode: false,
                        numberType: "MOBILE",
                        //onlyCountries: ['us', 'gb', 'ch', 'ca', 'do'],
                        //preferredCountries: ['cn', 'jp'],
                        preventInvalidNumbers: true,
                    });
                    $('#PhoneNumeberdiv').show();
                    $('#loadingMainImgDiv').hide();
                    $('#MessageDiv').hide();
                    $('#Passwordsection').hide();
                }

            })
           .fail(function (error, status) {

               if (error.status == 400) {
                   ResetForm();
                   logger.logError('The code is incorrect. Please try again.', 'Error', system.getModuleId(CpViewModel), true);
               }
               else if (error.status == 500) {
                   ResetForm();
                   logger.logError('Invalid URL Link. Please try again.', 'Error', system.getModuleId(CpViewModel), true);
               }
               else {
                   var msg = 'Exception: ' + error + ' | Source:ajaxFail method in ChangeUserPassword() method in ResetPassword.js';
                   logger.logMessage(msg);
               }
           })
        }
        catch (e) {
            var msg = 'Exception: ' + error.statusText + ' | Source: GetphoneNumber() method in ResetPasswords.js';
            logger.logMessage(msg);
        }
    }

    function VerifyPhoneNumber() {
        if ($("#numberprovider").intlTelInput("isValidNumber")) {
            $('#phonenumbervalidation').hide();
            $('#loadingMainImgDiv').show();
            var Countrycode = "+" + $("#numberprovider").intlTelInput("getSelectedCountryData").dialCode;
            var number = $("#numberprovider").intlTelInput("getNumber");
            number = number.substring(Countrycode.length, number.length);
            CpViewModel.PhoneNumber(Countrycode + "-" + number)
            var totallength = number.substring(number.length - 3, number.length);
            var countrycode = Countrycode + "-" + number.substring(0, 2);
            var completenumber = countrycode + "*****" + totallength;
            CpViewModel.MaskedNumber(completenumber)
            $('select option:contains("SMS")').text('Text me at ' + CpViewModel.MaskedNumber());
            $('select option:contains("Call")').text('Call me at ' + CpViewModel.MaskedNumber());
            ShowOptions();

            //you are at verify options in reset password page?
            //   CpViewModel.OtpText(CpViewModel.OtpText() + " " + jsonResult[1] + " with a verification code");
            //   VerifyTimePassword(Countrycode, number);
        }
        else {
            $('#phonenumbervalidation').show();
            $('#phonenumbervalidation').html('Please enter a valid Phone Number.')
        }


        // CreateOneTimePassword();
    }

    function ShowOptions() {
        try {
            $('#PhoneNumeberdiv').hide();
            $('#AuthenticateDiv').hide();
            $('#MessageDiv').show();
            $('#loadingMainImgDiv').hide();

        }
        catch (e) {
            var msg = 'Exception: ' + error.statusText + ' | Source: ShowOptions() method in ResetPasswords.js';
            logger.logMessage(msg);
        }
    }
    function VerifyTimePassword(Countrycode, number) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;

            $.ajax({
                url: "/api/Account/ValidatePhoneNumberChangePassword",
                type: "POST",
                headers: headers,
                contentType: 'application/json',
                data: JSON.stringify
                        ({
                            EmailId: CpViewModel.Email(),
                            Countrycode: Countrycode,
                            PhoneNumber: number
                        })
            })
                .success(function (jsonResult, status)
                {
                    if (jsonResult != null)
                    {
                        if (jsonResult.startsWith('INC')) {
                            logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CpViewModel), true);
                        }

                        else if (!jsonResult.startsWith('INC')) {
                            var totallength = number.substring(number.length - 3, number.length);
                            var countrycode = Countrycode + "-" + number.substring(0, 2);
                            var completenumber = countrycode + "*****" + totallength;
                            CpViewModel.OtpText('We\'ve sent you a text message on ' + completenumber + " with a verification code.")
                            $('#AuthenticateDiv').show();
                            $("#PhoneNumeberdiv").hide();
                            $('#MessageDiv').hide();
                            $('#loadingMainImgDiv').hide();
                        }
                    }
                    else
                    {
                        logger.logError('An error has occurred. Please contact your Administrator.', 'Error', system.getModuleId(CpViewModel), true);
                    }
})
.fail(function (error, status) {
    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in VerifyTimePassword() method in ResetPassword.js';
    logger.logMessage(msg);
});
        }
        catch (e) {
            var msg = 'Exception: ' + error.statusText + ' | Source: VerifyTimePassword() method in ResetPassword.js';
            logger.logMessage(msg);
        }

    }

    function AuthenticateOption(data, event) {
        try {
            //if ($('#ParentQuestionDropDown').val() == 'PhoneCall') {
            //    CpViewModel.OtpText('You will receive a call on ' + CpViewModel.MaskedNumber() + " with a verification procedure.")
            //    $('#MessageDiv').hide();
            //    $('#loadingMainImgDiv').hide();
            //    $('#Telephonecalldiv').show();
            //    $('#AuthenticateDiv').hide();
            //    CallPhone();
            //}
            //else {
            CpViewModel.OtpText('A code has been sent to you at ' + CpViewModel.Email() + ".Enter that code below.")

                $('#AuthenticateDiv').show();
                $('#MessageDiv').hide();
                $('#Telephonecalldiv').hide();
                $('#loadingMainImgDiv').show();
                CreateOneTimePassword()

            //}
        }
        catch (e) {
            var msg = 'Exception: ' + error.statusText + ' | Source: AuthenticateOption() method in ResetPassword.js';
            logger.logMessage(msg);
        }
    }

    function CallPhone() {
        try {
            $('#loadingMainImgDiv').show();
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Account/verifywithcallanonymous",
                type: "POST",
                headers: headers,
                data: { PhoneNumber: CpViewModel.PhoneNumber(), EmailId: CpViewModel.Email() }
            })
                .success(function (jsonResult, status)
                {
                    if (jsonResult != null && jsonResult.startsWith('INC'))
                    {
                        logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CpViewModel), true);
                    }

                    else if(jsonResult != null && jsonResult == 'true')
                    {
                        logger.logSuccess('User account verified successfully.', 'Success', system.getModuleId(CpViewModel), true);
                        $('#MessageDiv').hide();
                        $('#loadingMainImgDiv').hide();
                        $('#AuthenticateDiv').hide();

                        ResetPassword(CpViewModel.Email(), CpViewModel.NewPassword(), CpViewModel.ReEnterNewPassword());
                        logger.logSuccess('OTP has been successfully verified.', 'Success', system.getModuleId(CpViewModel), true);;
                        // logger.logSuccess('OTP has been successfully verified.', 'Success', system.getModuleId(CpViewModel), true);

                    }
                    else
                    {
                        logger.logError('Unable to verify account, Please contact Application Administrator.', 'Error', system.getModuleId(CpViewModel), true);
                        $('#loadingMainImgDiv').hide();
                        CpViewModel.Wrongattemptcount(CpViewModel.Wrongattemptcount() - 1)
                        $('#OTPValidationphcall').show();

                        if (CpViewModel.Wrongattemptcount() == 2) {
                            logger.logWarning('Please click on resend button.', 'Warning', system.getModuleId(CpViewModel), true);
                            $('#OTPValidationphcall').html(CpViewModel.Wrongattemptcount() + ' more attempts left.');
                        }

                        else if (CpViewModel.Wrongattemptcount() == 1) {
                            logger.logWarning('Please click on resend button.', 'Warning', system.getModuleId(CpViewModel), true);
                            $('#OTPValidationphcall').html(CpViewModel.Wrongattemptcount() + ' more attempt left.');
                        }
                        else if (CpViewModel.Wrongattemptcount() == 0) {
                            logger.logWarning('You have exceeded max. number of failure attempts.', 'Warning', system.getModuleId(CpViewModel), true);
                            $('#OTPValidation').html('You have exceeded max. number of failure attempts. Please login back.');
                            CpViewModel.appsecurity.logout()
                  .done(function (token) {
                      $("input[name='__RequestVerificationToken']").val(token);
                      appsecurity.clearAuthInfo();
                      window.location = routeconfig.login;
                  })
                  .fail(function (error) {
                      appsecurity.clearAuthInfo();
                      window.location = routeconfig.login;
                  });
                        }
                    }

                })
.fail(function (error, status) {
    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in NavigatetoClientSpeceficPage() method in ProjectAuthorizeMFA.js';
    logger.logMessage(msg);
});
        }
        catch (e) {
            var msg = 'Exception: ' + error.statusText + ' | Source: AuthenticateOption() method in ResetPassword.js';
            logger.logMessage(msg);
        }
    }
    function CreateOneTimePassword() {
        try {
            $('#loadingMainImgDiv').show();
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;

            $.ajax({
                url: "/api/Account/SendOTPRestPassword",
                type: "POST",
                headers: headers,
                contentType: 'application/json',
                data: JSON.stringify
                        ({
                            ProviderName: CpViewModel.ProviderName(),
                            //PhoneNumber: CpViewModel.PhoneNumber(),
                            Token: CpViewModel.QueryParams(),
                            EmailId: CpViewModel.Email()

                        })
            })
                .success(function (jsonResult, status)
                {
                    if (jsonResult != null && jsonResult.startsWith('INC'))
                    {
                        logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CpViewModel), true);
                    }

                    else if(jsonResult != null && jsonResult == 'true')
                    {
                        logger.logSuccess('OTP has been successfully sent to the registered Email address.', 'Success', system.getModuleId(CpViewModel), true);
                        $('#MessageDiv').hide();
                        $('#loadingMainImgDiv').hide();
                        $('#AuthenticateDiv').show();
                    }

                    else
                    {
                        $('#loadingMainImgDiv').hide();
                        ResetForm();
                        logger.logError('Unable to send OTP/Invalid Token, Please contact Application Administrator.', 'Error', system.getModuleId(CpViewModel), true);
                    }

})
.fail(function (error, status) {
    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in NavigatetoClientSpeceficPage() method in ResetPassword.js';
    logger.logMessage(msg);
});

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CreateOneTimePassword() method in AuthorizeMFA.js';
            logger.logMessage(msg);
        }
    }


    function SubmitOnetimepassword() {
        try
        {
            $('#loadingMainImgDiv').show();
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;

            $.ajax ({
                url: "/api/Account/ValidateOTPChangePassword",
                type: "POST",
                headers: headers,
                contentType: 'application/json',

                data: JSON.stringify
                        ({
                            ProviderName: CpViewModel.ProviderName(),
                            PhoneNumber: CpViewModel.PhoneNumber(),
                            Isverfiedphonenumber: false,
                            Token: CpViewModel.OTPPassword(),
                            EmailId: CpViewModel.Email()

                        })})

                .success(function (jsonResult, status)
                {
                    if (jsonResult != null && jsonResult.startsWith('INC'))
                    {
                        logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CpViewModel), true);
                    }
                    else if (jsonResult != null && jsonResult == 'True')
                    {
                        CpViewModel.Wrongattemptcount(3);
                        $('#loginPageLogo').hide();
                        ResetPassword(CpViewModel.Email(), CpViewModel.NewPassword(), CpViewModel.ReEnterNewPassword());
                        logger.logSuccess('OTP has been successfully verified.', 'Success', system.getModuleId(CpViewModel), true);
                    }
                    else
                    {
                        $('#loadingMainImgDiv').hide();
                        CpViewModel.Wrongattemptcount(CpViewModel.Wrongattemptcount() - 1)
                        $('#OTPValidation').show();

                        if (CpViewModel.Wrongattemptcount() == 2) {
                            logger.logWarning('Please enter a valid OTP.', 'Warning', system.getModuleId(CpViewModel), true);
                            $('#OTPValidation').html(CpViewModel.Wrongattemptcount() + ' more attempts left.');
                        }

                        else if (CpViewModel.Wrongattemptcount() == 1)
                        {
                            logger.logWarning('Please enter a valid OTP.', 'Warning', system.getModuleId(CpViewModel), true);
                            $('#OTPValidation').html(CpViewModel.Wrongattemptcount() + ' more attempt left.');
                        }

                        else if (CpViewModel.Wrongattemptcount() == 0)
                        {
                            logger.logWarning('You have exceeded max. number of failure attempts.', 'Warning', system.getModuleId(CpViewModel), true);
                            $('#OTPValidation').html('You have exceeded max. number of failure attempts. Please login back.');
                            router.navigate("", true);
                            CpViewModel.PageType("Screen");
                        }
                     }
                })
                .fail(function (error, status) {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in NavigatetoClientSpeceficPage() method in ResetPassword.js';
                    logger.logMessage(msg);
                });
        }
        catch (e)
        {
            var msg = 'Exception: ' + e + ' | Source: SubmitOnetimepassword() method in AuthorizeMFA.js';
            logger.logMessage(msg);
        }
    }

});

